﻿import { ThermalReceipt } from "@/components/ThermalReceipt";

export function ReceiptPreview({ formData }: { formData: any }) {
  return (
    <div className="hidden lg:block space-y-4">
      <h2 className="text-xl font-bold text-white flex items-center gap-2">
        Prévia do Recibo
      </h2>
      <p className="text-sm text-slate-400 mb-4">
        Veja como seu cliente recebe a via impressa.
      </p>

      <div className="bg-slate-900 border border-slate-800 p-6 rounded-2xl shadow-lg flex justify-center items-start relative min-h-[500px]">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 to-purple-500/5 rounded-2xl pointer-events-none"></div>

        <div className="relative z-10 w-full max-w-[300px]">
          <ThermalReceipt
            preview={true}
            company={formData}
            customer={{ name: "João da Silva" }}
            vehicle={{ plate: "ABC-1234", model: "Chevrolet Onix" }}
            order={{
              id: "12345678-abcd",
              created_at: new Date().toISOString(),
              total: 120.0,
              discount_amount: 0,
              status: "PAGO",
              services: [
                { name: "Ducha Simples", price: 50.0 },
                { name: "Cera Líquida", price: 70.0 },
              ],
            }}
          />
        </div>
      </div>
    </div>
  );
}
